var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#94BE43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5126 13.0011C18.3769 13.0031 18.2432 13.0587 18.149 13.1533C18.0548 13.247 18.0011 13.3787 18.0032 13.5094C17.9961 20.7439 18.0032 28.2671 18.0032 34.4897C18.0001 34.6224 18.0548 34.7551 18.151 34.8498C18.2473 34.9444 18.383 35 18.5207 35C18.6585 35 18.7942 34.9444 18.8904 34.8498C18.9867 34.7551 19.0414 34.6224 19.0383 34.4897V22.8532H31.4824C31.5867 22.8532 31.69 22.8219 31.7751 22.7654C31.8602 22.7088 31.928 22.6258 31.9655 22.5322C32.003 22.4385 32.0101 22.3341 31.9858 22.2356C31.9615 22.138 31.9058 22.0473 31.8288 21.98L28.0112 18.6501L31.8316 15.2645C31.9076 15.1972 31.9623 15.1065 31.9866 15.0089C32.0099 14.9113 32.0028 14.807 31.9653 14.7133C31.9279 14.6196 31.861 14.5377 31.7749 14.4811C31.6898 14.4245 31.5865 14.3933 31.4822 14.3933H19.0381V13.5074C19.0402 13.3737 18.9844 13.2401 18.8862 13.1464C18.789 13.0518 18.6502 12.9981 18.5124 13.0001L18.5126 13.0011Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.0663abe342e407cc0493cf7bea7568a9.svg";
export { ForwardRef as ReactComponent };